/* eslint-disable camelcase */
// import axios from "axios";
import { User, UserManager, UserManagerSettings } from 'oidc-client'
import {
  createUserManager,
  CallbackComponent,
  OidcProvider,
  reducer as OidcReducer,
  loadUser,
  UserState,
} from 'redux-oidc'

import Logout from '../../pages/logout'
import { getEnv } from '../env'

// Log.level = 4;
// let clientId = process.env.REACT_APP_OIDC_CLIENT_ID;
// let authority = process.env.REACT_APP_OIDC_CONFIGURATION_URL;
// let scope = process.env.REACT_APP_OIDC_SCOPE;

type TEnv = {
  OIDC_CLIENT_ID: string
  OIDC_SCOPE: string
  OIDC_CONFIGURATION_URL: string
  OIDC_RESPONSE_TYPE: string
  OIDC_RESPONSE_MODE: string
  OIDC_AUTOMATIC_SILENT_RENEW: string
  OIDC_FILTER_PROTOCOL_CLAIMS: string
  OIDC_POPUP_WINDOW_TARGET: string
}

const env = getEnv<TEnv>({
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID || 'REACT_APP_OIDC_CLIENT_ID missing',
  OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE || '',
  OIDC_CONFIGURATION_URL: process.env.REACT_APP_OIDC_CONFIGURATION_URL || 'REACT_APP_OIDC_CONFIGURATION_URL missing',
  OIDC_RESPONSE_TYPE: process.env.REACT_APP_OIDC_RESPONSE_TYPE || 'REACT_APP_OIDC_RESPONSE_TYPE missing',
  OIDC_RESPONSE_MODE: process.env.REACT_APP_OIDC_RESPONSE_MODE || 'REACT_APP_OIDC_RESPONSE_MODE missing',
  OIDC_AUTOMATIC_SILENT_RENEW: process.env.REACT_APP_OIDC_AUTOMATIC_SILENT_RENEW || 'REACT_APP_OIDC_AUTOMATIC_SILENT_RENEW missing',
  OIDC_FILTER_PROTOCOL_CLAIMS: process.env.REACT_APP_OIDC_FILTER_PROTOCOL_CLAIMS || 'REACT_APP_OIDC_FILTER_PROTOCOL_CLAIMS missing',
  OIDC_POPUP_WINDOW_TARGET: process.env.REACT_APP_OIDC_POPUP_WINDOW_TARGET || 'REACT_APP_OIDC_POPUP_WINDOW_TARGET missing',
})


const clientId = env.OIDC_CLIENT_ID
const scope = env.OIDC_SCOPE
const authority = env.OIDC_CONFIGURATION_URL
const automaticSilentRenew = (env.OIDC_AUTOMATIC_SILENT_RENEW === 'true')? true : false
const filterProtocolClaims = (env.OIDC_FILTER_PROTOCOL_CLAIMS === 'true')? true : false
const responseType = env.OIDC_RESPONSE_TYPE
const responseMode = env.OIDC_RESPONSE_MODE || "query"
const popupWindowTarget = env.OIDC_POPUP_WINDOW_TARGET || '_blank'

const userManagerConfig: UserManagerSettings = {
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }/authentication/callback`,
  popup_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }/oauth2-signin-callback.html`,
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }/authentication/silent_callback`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }${Logout.routeProps.path}`,
  popup_post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
    }${Logout.routeProps.path}`,
  popupWindowTarget,
  automaticSilentRenew,
  filterProtocolClaims,
  loadUserInfo: false,
  scope,
  response_type: responseType,
  response_mode: responseMode,
}

const userManager = createUserManager(userManagerConfig)
export default userManager

export { CallbackComponent, User, UserManager, OidcProvider, OidcReducer, loadUser, UserState }
